import TableStyles from "../../../styles/TableStyles.css";
import CommonStyles from "../../../styles/CommonStyles.css";

export const styles = (theme) => ({
  ...TableStyles,
  ...CommonStyles,

  globalHeader: {
    display: "flex",
    background: "#292929",
    alignItems: "center",
    zIndex: "8",
    position: "relative",
    padding: "13px 5px",
  },
  globalBlockCreateBox: {
    marginBottom: "10px",
    "& > div": {
      padding: "5px 20px",
      display:"flex",
      width:"100%",
      boxSizing: "border-box",
    alignItems: "center",
    "& > span":{
      margin:" 0 10px 0 0",
    fontSize: "12px",
    color: "#d7d4d4",
    }
    },  
    "& .MuiTextField-root":{
      width:"100%",
    },
   
  },
  roledividerMargin: {
    margin: "10px 10px  20px 10px ",
  },
  globalModuleWrap: {
    paddingTop: "25px",
  },

  moduleEdit: {
    float: "right",
    minWidth: "30px",

    background: "#212121",
    padding: "8px",
  },
  sidBarWrap: {
    // minWidth: "480px",
    position: "relative",
    overflow: "hidden",
    height: "100%",
    background: "#303030",
  },

  recipientLabel: {
    border: "1px solid rgba(81, 81, 81, 1)",
    borderRadius: "5px",
    padding: "0px",
    margin: "3px ",
    background: "#212121",
    display: "flex",
    alignItems: "center",
    textAlign:"left",
    "& .MuiAvatar-circle":{
      margin:"3px 8px 3px 3px",
      width:"24px",
      height:"24px",
    }
  },
  addUsersButton:{
  background: "#0C853E",
  boxShadow: "none",
  color: "#fff",
  textTransform: "none",
  fontWeight: "400",
  margin: "10px 0",
  fontSize:"12px",
  "&:hover": {
      background: "#1a1a1a",
      color: "#29D211",
  },
  "& svg":{
    fontSize: "19px",
  },

},
 

  sidBarInnerWrap: {
    left: " 0",
    width: "100%",
    height: "calc(100% - 0px)",
    position: "absolute",
    overflowX: "hidden",
    overflowY: "auto",
  },
  sidBarInnerContents: {
    padding: "20px",
  },
  tableMainView: {
    width: "100%",
    height: "calc(100% - 211px)",
    overflow: "auto",
    position: "absolute",
    background: "#000",
    marginTop: "0px",
    "& .MuiAvatar-square":{
      width:"30px",
      height:"30px",
      background: "#d8d8d5",
      borderRadius: "3px",
    },
      "& .playTrack": {
        top: "9px",
    },
  },
  chipContainer:{
    width:"100%",
  },
  tableFilterInput: {
  width:"100%",
  "& p.Mui-error":{
    margin:"8px 0",
    pointerEvents: "none",
  },
  "& input": {
    borderRadius: "5px !important",
    padding: "8.5px 27px 8.5px 8.5px",
     fontSize:"0.8em",
    background:"#2d2d2d",
  },
  "& div": {
    borderRadius: "5px !important",
    width:"100%",
    margin:"0 !important",
    justifyContent: "flex-start",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
    borderColor: "#46af22 !important",
  }
},
  clearanceFormHeader: {
    background: "#005371",
    fontSize: "1em",
    padding: "10px 5px 10px 20px",
    "& h1": {
      marginTop: "0",
      fontSize: "21px",
      fontWeight: "bold",
      marginBottom: "0", 
    position: "relative",
    textOverflow: "ellipsis",
    overflow:"hidden" ,
    whiteSpace: "nowrap",
    width: "auto",
    },
    "& .cfSeries":{
      "& nav .MuiCircularProgress-colorPrimary":{
        color: "#fff",
        width: "30px !important",
        height: "30px !important",
      }
    }
  },
  seriesMasterLabel:{
    color:"#dbbf63",
    textTransform:"uppercase",
    "& span":{
      fontWeight:"bold",
    }

  },
  clearanceFormHeaderDetails: {
 fontSize: "0.75em",
    "& span.titleSpan": {
      textTransform: "uppercase",
      minWidth: "215px",
      display: "inline-block",
    },
    "& .MuiCircularProgress-colorPrimary": {
      color: "white",
      width: "20px !important",
      height: " 20px !important",
    },
    marginBottom: "5px",
    textOverflow: "ellipsis",
    paddingRight: "10px",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  clearanceButtonMargin: {
    margin: "1px 5px  0 0",
    borderRadius: "5px",
    "& svg":{
      fontSize:"34px",
    },
    "& .MuiBadge-dot": {
      height: "14px",
      padding: "0",
      minWidth: "14px",
      borderRadius: "50%"
   },
  "&  .MuiBadge-colorSecondary":{
    backgroundColor: "#fff!important"
  }
  },
  clearanceSign: {
    minWidth: "20px",
    height: "20px",
    borderRadius: "50%",
    margin: "5px 10px 5px 0px",
    display: "inline-block",
    verticalAlign: "middle",
  },
  inlineWizardRun:{
    background:"red",
  },
  clearanceList: {
    "& .helpTooltip ":{
      float: "inherit", 
      width: "inherit",
     minWidth: "inherit !important",
     fontSize: "inherit !important", 
      position:" inherit !important", 
      right: "inherit",
     marginLeft: "auto !important",
     paddingRight: "0 !important",
 },
    "&  .MuiMenu-list": {
      minWidth: "230px",
      maxWidth: "230px",
    },
    "& .MuiOutlinedInput-root": {
      width: " 100%",
    },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      padding: "6px 32px 8px  8px!important",
      marginTop: "0",
      "& > div": {
        margin: "0px 9px 0px 10px",
      },
    },
  },
  addTrackML:{
    fontSize:"16px",
    margin:"20px 0 10px 0",
    color:"#ffb932",
    fontWeight:"bold",

  },
  clearanceOverride: {
    padding: "0 15px",
    marginBottom: "8px",
    "& label": {
      fontSize: "12px",
      margin: "8px 0 7px 0",
      display: "block",
      borderTop: "1px solid #676767",
      paddingTop: "10px",
    },
    "& .MuiSelect-select":{
      paddingTop: "4px",
    paddingBottom: "4px",
    maxWidth:"150px",
    }
  },
  buttonDivider:{
    background: "#676767",
    height:"1px",
    border:"none",
  },
 allocatToUser:{
  borderTop: "1px solid #676767",
  padding: "0 15px",
  marginBottom: "16px",
    "& .MuiAutocomplete-inputRoot":{
    padding: "0 0 0 5px",
    fontSize: "12px",
    },
    "& label": {
      fontSize: "12px",
      margin: "5px 0 8px 0",
      display: "block",
      paddingTop: "10px",
    },
    "& .MuiSelect-select":{
      paddingTop: "4px",
    paddingBottom: "4px",
    maxWidth:"150px",
    },
    "& .MuiSelect-outlined.MuiSelect-outlined":{
      padding: "8px 10px !important",
    marginTop: "0",    
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
    },
  },
  clearanceIcon: {
    marginRight: "8px",
    fontSize: "18px",
    "& path":{
      stroke:"#fff",  
    }
  },
  clearanceLivePopup: {
    minWidth: "450px",
    padding: "5px 0px 15px 0px",
    "& .MuiDialogTitle-root": {
      margin: "0",
      padding: "8px 24px",
      borderBottom: "1px solid #616161",
      paddingBottom: "5px",
      marginBottom: "15px",
    },
    "& .MuiDialogActions-root": {
      paddingRight: "15px",
    },
    "& .MuiCircularProgress-colorPrimary": {
      color: "white",
      width: "20px !important",
      height: " 20px !important",
    },
  },
  clearanceLiveTrackName: {
    fontSize: "14px",
    padding: "0 25px",
    whiteSpace: "pre-wrap",
    maxWidth: "350px",
  },
  tableFilterInput: {
    width: "100%",
    "& input": {
      borderRadius: "4px !important",
      padding: "7px 27px 7px 30px",
       fontSize:"0.8em",
       width:"100%",
    },
    "& div": {
      borderRadius: "4px !important",
      width: "100%",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#46af22 !important",
      borderWidth: "1px !important",
    },
    "& label": {
      fontSize: "12px",
      top: " -10px !important",
      left: "20px",
    },
    "& .MuiInputLabel-shrink": {
      top: "2px !important",
      left: "0px",
    },
    "& .Mui-focused": {
      color: "#fff !important",
    },
  },
  tableFilterClear: {
    position: "absolute",
    right: "0",
    top: "0",
    minWidth: "28px",
    padding: "8px 5px!important",
  },
  trackNotesIcon: {
     fontSize:"1em",
    color: "green",
  },
  trackNotesIconEmpty: {
    color: "gray",
  },
  varientClass:{
    background:"red",
  },
  globalCreateErrWrapper:{
    margin: "6px 0 10px 38px",
  color:"#FFD1D1   !important",
  fontSize:"12px",
  },
  clearanceDeadline:{
    "& .MuiOutlinedInput-input":{
    padding:"9px 14px",
    fontSize:"12px",
  },
  width:"100%",
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
    borderColor:"#46af22",
  }
  },
  genreDropdownContainer:{
    marginLeft: "20px",
    // Added Breakpoints
      [theme.breakpoints.down("sm")]: {
        marginLeft: "0",
      },
      [theme.breakpoints.up("md")]: {
        marginLeft: "0",
      },
      [theme.breakpoints.up("lg")]: {
        marginLeft: "20px",
      },
  },
  inputBorder:{
    "& input" :{
      padding: "10px 10px 8px 10px !important",
      border: "1px solid #4f7f94 !important",
  }
  },
  clearanceFormLabels:{
  "& > div":{
    display:"flex",
  },
    "& .genreLableSpan":{
      marginLeft:"0 !important",
    },
    "& .MuiTextField-root":{
      // marginRight:"10px",
    },
    "& textarea":{
      color: "#fff",
    width:" 100%",
    border: "1px solid #4f7f94",
    resize: "none",
    padding: "10px",
    fontSize: "0.8em",
    maxWidth: "100%",
    background: "#1a5974",
    boxSizing: "border-box",
    maxHeight: "220px",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif , 'Segoe UI', 'Roboto', 'Oxygen'",
    borderRadius: "3px",
    outline:"none",
    "&:focus":{
      borderColor: "#46af22 !important",
    },
    "&:hover":{
      borderColor: "#46af22 !important",
    },
    }
  },

  mainEditSynopsis:{
    "& .MuiTextField-root":{
      minWidth:"inherit",
    },
  },
  genreSelectBox:{
    margin:"0",
    width: "100%",
    overflow: "hidden",
    "&:hover .MuiOutlinedInput-notchedOutline":{
      borderColor:"#46af22",
    }
  },
  genreAutoSelectBox:{
    margin:"0",
    width: "100%",
    background: "#19688a",
    "&:hover .MuiOutlinedInput-notchedOutline":{
      borderColor:"#46af22",
    },
    "& .MuiOutlinedInput-root":{
      padding: "0",
      fontSize: "12px",
    },
    "& input":{
      background:"#19688a",
      paddLeft:"15px !important",
    }
  },
  justifyEnd:{
    justifyContent:" flex-end",
  },
  editModeDiv:{
    background: "#004963",
    padding: "10px 10px 5px 10px",
    marginBottom: "12px",
    borderRadius:"4px",
    width:"100%",
  },
  clearanceEditTitleMain:{
    display:"flex",
    margin:"10px 20px 10px 0px",
    alignItems:" flex-start",
    alignItems:"center",
  },
  mainEditWrapper:{
    width:"100%",
  },
  clearanceEditTitle:{  
    marginBottom:"5px",
    "& > div":{
      display:"block",
      alignItems: "center",
      marginBottom: "0px",
      "&  > div.seperator":{
        margin:"0 5px",
      }
    },
    "& input":{
      background:"#1A5974",
    },
    "& .MuiSelect-selectMenu": {
      paddingRight:" 32px",
      background: "#19688a",
      paddingTop: "7px",
      paddingBottom: "6px",
      textAlign:"left", 
    },
    "& label.genreLableSpan":{
      whiteSpace: "nowrap",
    margin: "0 0 5px 0",
    display:"block",
    alignItems: "inherit",
    textTransform: "uppercase",
    fontSize: "11px",
    minWidth: "160px",
    }
  },
 
  globalCreateSaveButton: {
    background: "#0C853E",
    boxShadow: "none",
    color: "#fff",
    border:"1px solid #0C853E",
    textTransform: "none",
    fontWeight: "400",
    margin: "0px",
    padding:"5px 15px",
    fontSize:"0.75em",
    "&:hover": {
        background: "#000",
        color: "#29D211",
        border:"1px solid #403f3f",
    },
    "& .MuiCircularProgress-colorPrimary":{
      width: "13px !important",
      height: "13px !important",
      color: "#fff !important",
      marginLeft: "5px !important",
    },
  },
  clearanceHelp:{
    display:"flex",
    "& .helpTooltip":{
      position:"relative !important",
    },
    "& .MuiAutocomplete-hasPopupIcon":{
      width:"100%",
    },  
  },
  clearanceHelpQuest:{
    "& svg":{
      color: "#ff6f6f",
        margin: "0 0px 0 8px",
        fontSize: "1.5em",
        verticalAlign: "bottom",
    }
  },
  clearanceTitleMsgContainer:{
    display:"flex",
    alignItems: "flex-start",
 
  },
  clearanceFormStatus:{
    "& span":{
      display: "inline-block",
       fontSize:"1em",
      fontWeight: "400",
      verticalAlign: "middle",
      marginBottom: "0",
      marginRight:"5px",
      "& span":{
        marginRight:"10px",
      }
    },  
    fontSize: "0.95em",
    marginRight:"30px",
    display:"inline-block",
    verticalAlign: "middle",
 
  },
  workflowSelectBox:{
    maxWidth:"160px",
    "& .MuiSelect-select":{
      padding:"8px 32px 8px 10px",
    },
    "& .MuiSelect-outlined.MuiSelect-outlined":{    
    fontSize: "1em !important",    
    }
  },

  allocateWrapperSpan:{
    display:"block",
    margin:"0",
    padding:"15px 0 0px 15px",
    borderTop:"1px solid #5a5a5a",
    fontSize:"0.8em",
  },
  allocateWrapperSpanAddMarginTop:{
    marginTop:"15px",
  },
  allocateWrapper:{
    padding:"10px 0px",
    fontSize:"1em",
    minWidth:"200px",
    "& .helpTooltip":{
      position:"relative !important",
    },
    "& > span":{
      display:"block",
      marginBottom:"5px",
    },
    "& .MuiAutocomplete-popupIndicator":{
      padding:"0 !important",   
      marginTop: "2px",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
      borderColor:"#46af22",
    },
    "& input":{
      fontSize:"12px",
      padding:"0px !important",
    },
    "& .MuiOutlinedInput-root":{
      width: "100%",
      "& .MuiSelect-select":{
        paddingTop: "10px",
        paddingBottom: "10px"
      }
    }
  },

  noData:{
    display:"block",
    textAlign:"center",
    padding:"10px",
    fontSize: "12px",
    position: "absolute",
    left: "0",
    right: "0",
    top:"130px"
  },

  
playerPopContainer:{
  marginTop:"20px",
  "& > div":{
      paddingLeft:"0 !important",
      margin:"0",
      width:"100%",
  },
  "& .duration-container":{
      right: "12px",
      marginTop: "40px",
  },
  "& .popupWave":{
      height:"57px !important",
  },
  "& .MuiSlider-root":{
      marginTop: "0",
      marginLeft: "5px",
      marginRight: "15px",
  },
  "& .MuiCircularProgress-indeterminate":{
      width: "20px !important", 
     height: "20px !important",
      margin: "20px auto",
      position: "relative !important",
      color: "#fff !important",
 }
},


  prsButton:{
    background: "#0f79ad",
    color: "#fff",
    borderColor: "#0f79ad",    
    "&:hover":{
      background:"#1b8dc5",
      borderColor: "#0f79ad",   
      color: "#fff", 
    }
  },
  displayResults:{
    color:"#e2e2e2",
    fontSize:"0.8em",
    padding:"5px 0 15px 0",
    "& span":{
      color:"#7ed0ff",
      fontWeight:"500"
    }
  },
  prsImported:{
     "& label":{
       color:"#0fadfb",
     }
  },
  chipsContainer:{
    width:"100%",
    "& .MuiFormControl-root":{
      width:"100%",
      background: "#2d2d2d",
    },
    "& .MuiOutlinedInput-root":{
      padding:"0",
      background: "#2d2d2d",
    },
    "& .MuiOutlinedInput-input":{
      margin:" 0",
      background: "#2d2d2d",
    },
    "& .MuiChip-root":{
      margin: "5px",
  },
  },
  gridOverFlowContainer:{
    overflow: "auto",
    height: "390px",
  },
  resetDataButton:{
    marginLeft:"10px !important",
  },
  addllDropdown:{

    "& .MuiOutlinedInput-input":{
      background:"#5d5d5d",
      border: "none !important",
      "&:hover":{
        background:"#868686",
        border:"none",
        borderRadius:"3px",
      },
      "&:focus":{
        background:"#868686",
        border:"none",
        borderRadius:"3px",
      }
    },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "none !important",
        borderWidth:" 0px !important",
        borderRadius:"3px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important",     
  }
  },
  toolTipSpan:{
    "&:focus":{
      outline:"none",
      "& .MuiListItem-root.Mui-disabled":{
        background:"none",
      },
      "& .MuiListItem-root":{
        background:"rgba(255, 255, 255, 0.08)"
      },     
    }
  },
  containDiv:{
    display:"block !important",
    "& .MuiFormHelperText-root.Mui-error": {
      fontSize:"12px"
  }
  },

  activeRadio2:{
    position: "relative",
    background:"#16A168 !important",
    "&:after":{
      content: "''",
      borderLeft: "9px solid transparent",
      borderRight: "10px solid transparent",
      borderBottom: "9px solid #424242",
      position: "absolute",
      left: "47%",
      margin: "0 auto",
      bottom: "0",
      display: "block",
      textAlign: "center",
    }
  },
  activeHover:{
    "&:hover":{
      background:"#16A168 !important",
    },
    "& label":{
      padding:"10px 15px",
    }
  },
  activeRadio:{
    background:"#16A168 !important",
    opacity:"1 !important",
    position: "relative",
    "& label":{
      color:"#fff !important",
    },
    "&:after":{
      content: "''",
      borderLeft: "9px solid transparent",
      borderRight: "10px solid transparent",
      borderBottom: "9px solid #424242",
      position: "absolute",
      left: "0",
      right: "0",
      width: "2px",
      margin: "0 auto",
      bottom: "0",
      display: "block",
      textAlign: "center",
    }
  },
  requiredField:{
  // color:"#FFA2A2",
  },
  mainQuestions:{
    width:"auto !important",
    padding: "0 !important",
    "& .MuiFormControlLabel-root":{
      color:"#fff"
    },
    "& .MuiFormGroup-root":{
      flexDirection:"row",
      "& > span":{
        margin:"0 10px 0 0",
        borderRadius:"5px",
      }
     
    }
   
  },
  dialogNoButton:{
    background:"#505050",
    fontSize:"12px",
    "&:hover":{
      background:"#000",
      color:"#fff",
    }
  },

  colorThemeOne:{
    // background:"#16A168",
    background:"#5b5b5b",
    cursor:"pointer",
    color:"#fff",
    "&:hover":{
      background:"#16a168",
    },
    "& .MuiRadio-colorSecondary.Mui-checked":{
      color:" #fff !important",
    },
    "& label":{
      padding:"10px 20px",
    },
    "& .MuiFormControlLabel-root":{
      padding:"10px 20px",
    },
  },
  colorThemeTwo:{
    // background:"#2a769b",
    background:"#5b5b5b",
    color:"#fff",
    cursor:"pointer",
    "&:hover":{
      background:"#16a168",
    },
    "& .MuiRadio-colorSecondary.Mui-checked":{
      color:" #fff !important",
    },
    "& label":{
      padding:"10px 20px",
    },
    "& .MuiFormControlLabel-root":{
      padding:"10px 20px",
    },
  },
  colorThemeThree:{
    // background:"#16A168",
    cursor:"pointer",
    background:"#5b5b5b",
    color:"#fff",
    "&:hover":{
      background:"#16a168",
    },
    "& .MuiRadio-colorSecondary.Mui-checked":{
      color:" #fff !important",
    },
    "& label":{
      padding:"10px 20px",
    },
    "& .MuiFormControlLabel-root":{
      padding:"10px 20px",
    },
  },


  noPaddindMargin:{
    padding: "20px 0px",
    borderBottom: "1px solid #555",
    width:"100%",
    marginBottom:"10px",
    "& h3":{
      margin:"0",
      padding:"10px 0",
      fontSize: "14px",
    },
    "& .MuiTypography-root":{
      fontSize: "14px",
      paddingLeft:"5px",
    }
  },
  
  newQuestionsBlock:{
    padding:"0px",
    "& label":{
      lineHeight: "20px",
      margin:"0 0 5px 0",
      fontSize: "14px",
      fontWeight:"bold",
    display: "inline-block",
    "& img":{
      display: "inline-block",
      maxWidth: "38px !important",
      verticalAlign:"middle",
      marginRight:" 10px",
    }
    },
    "& .MuiFormGroup-root label":{
      margin:"0",
    },
    "& .MuiFormControlLabel-label":{
      fontSize:"13px",
      fontWeight:"bold",
      "& label":{
        fontWeight:"bold",
      }
    },
    "& .MuiSelect-select":{
      padding:"8px 10px",
      background:"#575757",
    },
  },
  questionLabels:{
    display:"flex",
    minWidth:"500px",
    alignItems:"center",
    maxWidth:"500px",
    "& label":{
      margin:"0 0 5px 0",
      paddingLeft:"10px",
    },
    "& > span":{
      margin:"0 5px",
    },
    "& h6":{
      paddingLeft: "10px",
      fontWeight: "bold",
      color: "#ffefb0",
      fontSize: "14px"
    },
  },
  formErrorRadio:{
    "& .MuiRadio-root":{
      color:"#9C214E!important",
    }

  },
  MuiError:{
    background:"Red",
  },
  clearanceSearchArea: {
    boxSizing:"border-box",
    alignItems: "start",
    position:"relative",
    zIndex:"99", 
    marginBottom: "0px",
    minWidth: "480px",
    marginRight: "auto",
    marginTop: "13px",
    "& .MuiListItem-button:hover": {
      background: "#424242",
    },
    "& .MuiListItem-button .active": {
      background: "#424242",
    },
    "& .MuiChip-outlined": {
      border: " 1px solid rgb(255 200 0)",
      fontSize: "12px",
      backgroundColor: "transparent",
      height: "30px",
      "& .MuiChip-label": {
        color: "rgb(255 200 0)",
      },
    },
    "& .dropdown-menu": {
      background: "#383838",
      color: "#fff",
      "& a":{
        color:"#fff",
        padding:"10px",
        display: "block",
        borderBottom:"1px solid #535353",
        fontSize: "12px",
      }
    },
    "& .dropdown-menu a.disabled": {
      background: "#383838",
      padding: "10px",
      fontSize: "12px",
      display: "block",
      color: "#ffcb0e",
      border: " 1px solid #6d6a6a",
      borderTop: "none",
      borderRadius: "0px 0px 3px 3px",
    },
    "& .MuiChip-root": {
      fontSize: "12px",
      marginRight: "5px",
      marginBottom: "5px",
    },
    "&  input": {
      padding: "10px",
      background: "#5a5a5a",
      borderRadius: "3px",
      height:"inherit",
      minWidth:"500px",
      color: "#fff",
      border: "1px solid rgba(255, 255, 255, 0.23)",
      fontSize: "12px",
      width: "100%",
      boxSizing: "border-box",
    },
    "& input:focus": {
      borderColor: "#46af22 !important",
      outline: "none",
    },
    "& input:hover": {
      borderColor: "#46af22 !important",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
      borderColor:"#46af22 !important",
    }
  }, 
  closeButton: {
    boxShadow: "none",
    color: "#F8F8F8",
    textTransform: "none",
    float: "right",
    fontWeight: "400",
    borderRadius:"5px",
    minWidth: "0px",
    padding: "7px 10px !important",
    width:"32px",
    marginLeft: "10px",
    marginLeft:"auto",
    border:"1px solid #242424",
    background:" #242424",
    marginRight:" 0",
    marginLeft: "auto",
    "& svg":{
      fontSize: "16px !important",
      margin: "0 !important",
    },
    "&:hover": {
      background: "#000000",
      boxShadow: "none",
    },
  },
  questionGroup:{
    display:"flex",
    padding: "10px 0",
    alignItems:"center",
    borderRadius:"5px",
    "& .Mui-error .MuiOutlinedInput-input":{
      background:  "#9C214E !important"
    },
    "& .MuiInputBase-input":{
      borderColor: "rgba(255, 255, 255, 0.23)  !important",
      borderRadius:"5px",
      background: "#505050",
      border:"1px solid",
      fontSize:"13px",
      padding:"10px 10px 8px 10px",
      "&:hover":{
        borderColor: "#46af22 !important",
      },
    },
    "& .Mui-error": {
      fontSize:"12px",
      "& .MuiSvgIcon-root":{
        color:"#fff",
      },
      "& .MuiInputBase-input": {
        background: "#9C214E!important",
      }
    },
    "& .MuiAutocomplete-hasPopupIcon":{
      "& .MuiOutlinedInput-input":{
        borderColor:"transparent  !important",
        paddingLeft:"10px !important",
      },
      "& .MuiAutocomplete-inputRoot":{
        background:" #505050",
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":{
        borderColor:"#46af22  !important"
      },
      "& .MuiInputBase-input:hover":{
        borderColor:"transparent  !important"
      },
      "&.MuiInputBase-input:hover":{
        borderColor:"#46af22  !important"
      },
    },
    "& span.Mui-error":{
      width:"100%",
      paddingTop:"5px",
      display:"block",
    },
    "& .MuiFormGroup-root":{
      flexDirection: "row",
      alignItems: "center",
      "& label":{
        marginRight:"15px",
      }
    },
    "& div":{
      width:"100%",
      "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":{
        borderColor: "#46af22"
      },
      "& .MuiOutlinedInput-input": {
        padding: "9px",
        fontSize: "13px",
        background: "#505050",
        fontWeight: "400!important",
    },
      "& .Mui-error": {
        "& .MuiInputBase-input": {
          background: "#9C214E!important",
        }
      },
    "& .MuiInputBase-adornedEnd":{
      padding:"2px 0 !important",
      background:"#505050",
      "& input":{
        border:"none",
      },
      "& div":{
        width:"auto",
        "& .MuiSvgIcon-root":{
          fontSize:"1.5rem",
          color:"#fff"
        }
      }
    },
   
    },
    "& .MuiAutocomplete-popupIndicator":{
      marginRight: "-5px"
    }
  },
  durationPicker:{
    margin:"0 0px 0 -2px",
    display:"flex",
    "& label":{
      padding: "0",
      fontSize: "13px",
      fontWeight: "normal",
      color: "rgba(255, 255, 255, 0.7)",
      flexBasis: "50%",
      flexGrow: "0",
    "& input":{
      padding:"8.5px 13px 8.5px 8.5px",
      background: "#505050",
      borderRadius:" 3px",
      border: "1px solid",
    },
    "& .MuiFormControl-root":{
      width:"100%",
    }
    },
    "& .MuiFormControl-root":{
      "& .MuiInput-underline:before":{
        borderColor:"rgba(255, 255, 255, 0.23)",
        borderRadius: "5px",
      },
      "& .MuiInput-underline:after":{
        borderColor:"#46af22",
        borderRadius: "5px",
      }
    },
  },
  tableFilterDate: {
    marginTop: "0",
    marginBottom: "0",
    "& input": {
      padding: "10px 10px 8px 10px !important",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline": {
      border: "1px solid rgb(76 76 76) !important",
      background: "transparent !important",
      "& button": {
        borderRadius: "5px",
      },
      "& .MuiButton-root": {
        width: "30px",
        height: "30px",
      },
      "& .MuiIconButton-root": {
        width: "30px",
        height: "30px",
      },
      "&:hover": {
        borderColor: "#46af22",
      },
      "&:focus": {
        borderColor: "#46af22",
      }
    },
    "& .Mui-focused": {
      borderColor: "#46af22",
    },
    "& .MuiInputAdornment-root": {
      width: "auto",
      marginRight: "3px",
      "& svg": {
        width: "18px",
      }
    },
    "& .Mui-disabled .MuiInputAdornment-root": {
      marginRight: "28px",
    },
  },
  dateDropdownPicker:{
    display:"flex",
    margin:"0 -5px",
    "& .MuiFormControl-root":{
      padding: "0 5px",
      "& .MuiInput-underline:before":{
        borderColor:"rgba(255, 255, 255, 0.23)",
        borderRadius: "5px",
      },
      "& .MuiInput-underline:after":{
        borderColor:"#46af22",
        borderRadius: "5px",
      }
    },
    "& .MuiSelect-select":{
      borderRadius:"5px",
      fontSize:"13px"
    }
  },
  clearanceWizardFooter:{
    padding:"15px 26px 15px 0",
  },
  iconButtonsGroup:{
    display:"block",
    "& label":{
      color:"#fff",
      fontWeight:"normal",
      fontSize: "12px",
      margin:"0",
      textAlign:"center",
      cursor:"pointer",
      "&.clearanceLabelName":{
        display:"block",
        textAlign:"left",
      },
    },
    "& input":{
      position:"absolute",
      left:"-9999px",
    },
    "& div":{
      display:"inline-block",
      cursor:"pointer",
      verticalAlign:"top",
      marginRight: "10px",
      borderRadius: "5px",
      // padding: "10px 15px",
      width: "150px",
      boxSizing:" border-box",
      "&.singleLabel":{
        display:"block",
        width:"100%",
        padding:"0",
        "& label":{
          color:"#fff",
          fontWeight:"bold",
          fontSize:"13px",
          margin:"0 0 5px 0",
          paddingLeft:"0",
        }
      }
    }
  },

nameTextField:{
  width:"100%",
  fontSize:"12px",
  "& textarea":{
    maxWidth: "100%",
    background: "#505050",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    borderRadius: "4px",
    padding: "10px!important",
    boxSizing:" border-box",
    color:"#fff",
    outline:"#46af22",
  resize: "vertical",
    "&:focus-visible":{
      borderColor: "#46af22 !important",
    }
     
  },
    "& > div":{
    width:"100%",
    display:"block",
    flexDirection: "inherit",
    "& p.Mui-error":{
      margin:"0",
      pointerEvents: "none",
    },
  }
},
  buildNotesAddButton:{
    margin:"0",
    padding:"5px 10px 4px 10px",
  },
  boldSeperator:{
    color:"yellow",
    margin:"0 2px"
  },
  wizardPopup:{
    maxWidth:"84%",
    margin:"0 auto",
    "& > div[aria-hidden='true']":{
      backgroundColor:"rgba(0, 0, 0, 0.9) !important",
    }
  },
  stickMainContainer:{
    overflowY:"auto",
    overflowX:"hidden",
    height:"100%",
    background:"#000",
    border:"2px solid #5a5a5a",
  },
  indexNumber:{
    minWidth:"24px",
  },
  customErrorAlign:{
    textAlign:"left",
    paddingLeft:"23px",
  },
  appbarZindex:{
    zIndex:"999",
  },
  textAreaBLock:{
    width:"100%",
    "& .Mui-error":{
      marginLeft:"0 !important", 
    }
  },
  AutoCompleteContainer:{
    "& .MuiAutocomplete-popper":{
      minWidth:"200px"
    }
  },
  
});
